import React from "react";
import { ReactComponent as EditIcon } from "../../assets/icons/management/edit.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/management/info.svg";
import { IProduct } from "../../types/product.type";
import styles from "./styles.module.scss";

interface Props {
  products: IProduct[];
  callBackInfo: (bool: boolean) => void;
  callBackEdit: (user: IProduct) => void;
}

const ProductsTable: React.FC<Props> = (props) => {
  return (
    <table className={styles.customTable}>
      <thead>
        <tr>
          <th>Продукт</th>
          <th>Бренд</th>
          <th>Capacity</th>
          <th>Price</th>
          <th>Статус</th>

          <th></th>
        </tr>
      </thead>
      <tbody>
        {props.products &&
          props.products.map((product, index) => (
            <tr key={product.id}>
              <td>
                <div className={styles.userInfo}>
                  {product.previewImageUrl ? (
                    <img
                      src={product.previewImageUrl}
                      className={styles.avatar}
                      alt="Avatar"
                    />
                  ) : (
                    <div className={styles.avatarEmpty}></div>
                  )}
                  <div className={styles.nameContainer}>
                    <span className={styles.name}>{product.name}</span>
                  </div>
                </div>
              </td>
              <td className={styles.role}>{product.brand.name}</td>
              <td className={styles.role}>{product.capacity}</td>
              <td className={styles.role}>
                {product.price}/{product.wholeSalePrice}
              </td>
              <td className={styles.role}>
                {product.avaliable ? "Опубліковано" : "Не опубліковано"}
              </td>
              <td>
                <div className={styles.actions}>
                  <button
                    className={styles.editBtn}
                    onClick={() => {
                      props.callBackInfo(false);
                      props.callBackEdit(product);
                    }}
                  >
                    <EditIcon />
                  </button>
                  <button
                    className={styles.infoBtn}
                    onClick={() => {
                      props.callBackInfo(true);
                      props.callBackEdit(product);
                    }}
                  >
                    <InfoIcon />
                  </button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default ProductsTable;
